// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__wqEpD","layout-body":"style_layout-body__xAZH2"};